// import React, { useEffect, useState } from "react";
// import { Button, Card, Col, Row, Form } from "react-bootstrap";
// import schoolApi from "../../api/schoolApi";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Link } from "react-router-dom";
// import Confirm from "../Confirm";
// import { usePermissions } from "../contexts/PermissionContext";
// import { Helmet } from "react-helmet";

// function SettingList({ setAttendanceType, tabName }) {
//   const [isedit, setisEdit] = useState(true);
//   const [buttonvalue, setButtonvalue] = useState("Edit Settings");
//   const { rolePermissions, userInfo } = usePermissions();
//   const [body, setBody] = useState([]);
//   const [feeFrequency, setfeefrequency] = useState(0);
//   const [lateFees, setlateFees] = useState(0);
//   const [feesPandingDays, setfeesPandingDays] = useState(0);
//   const [attendanceMode, setattendanceMode] = useState("daily");
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const [resultMode, setResultMode] = useState("percentage");
//   const [gradedata, setgradedata] = useState("");
//   const canCreate = rolePermissions?.session_list?.can_create;

//   const [tempColor, setTempColor] = useState("#000000");
//   const [showBloodGroup, setShowBloodGroup] = useState(false);

//   useEffect(() => {
//     fetchAllSettings();
//     fetchgrade();
//   }, []);

//   const fetchgrade = async () => {
//     try {
//       const data = await schoolApi.fetchgrade();
//       if (data && data.grades) {
//         setgradedata(
//           data.grades.map((grade) => ({ ...grade, isupdate: false })),
//         );
//       } else {
//         setgradedata([]);
//       }
//     } catch (error) {
//       console.error("Error fetching grades:", error.message);
//     }
//   };

//   async function fetchAllSettings() {
//     try {
//       const result = await schoolApi.getAllSetting();

//       if (result && result.data) {
//         console.log("Fetched settings:", result.data);

//         // Check if id_card_color and blood_group exist
//         const hasIdCardColor = result.data.some(r => r.key === "id_card_color");
//         const hasBloodGroup = result.data.some(r => r.key === "blood_group");

//         let settingsData = [...result.data];

//         // If missing, add them to the list
//         if (!hasIdCardColor) {
//           console.log("Adding missing id_card_color setting");
//           settingsData.push({
//             id: null,
//             key: "id_card_color",
//             value: "#000000",
//             isenabled: true,
//             description: "ID Card Color",
//             isupdate: true
//           });
//         }

//         if (!hasBloodGroup) {
//           console.log("Adding missing blood_group setting");
//           settingsData.push({
//             id: null,
//             key: "blood_group",
//             value: false,
//             isenabled: true,
//             description: "Show Blood Group on ID Card",
//             isupdate: true
//           });
//         }

//         setBody(settingsData.map((element) => ({ ...element, isupdate: false })));

//         // Set state variables
//         settingsData.forEach((element) => {
//           switch (element.key) {
//             case "frequency":
//               setfeefrequency(parseInt(element.value) || 0);
//               break;
//             case "Attendentce_Mode":
//               setattendanceMode(element.value);
//               break;
//             case "pending_due_day":
//               setfeesPandingDays(parseInt(element.value) || 0);
//               break;
//             case "late_fee":
//               setlateFees(parseInt(element.value) || 0);
//               break;
//             case "result_mode":
//               setResultMode(element.value);
//               break;
//             case "id_card_color":
//               setTempColor(element.value || "#000000");
//               break;
//             case "blood_group":
//               const isBloodGroupEnabled = element.value === true || element.value === "true";
//               setShowBloodGroup(isBloodGroupEnabled);
//               break;
//             default:
//               break;
//           }
//         });
//       }
//     } catch (error) {
//       console.error("Error during fetchAllSettings:", error);
//       toast.error("Something went wrong");
//     }
//   }

//   const EditSetting = () => {
//     if (buttonvalue === "Edit Settings") {
//       setisEdit(false);
//       setButtonvalue("Save Settings");
//     } else {
//       // Before saving, ensure all settings are marked for update
//       setBody(prev => prev.map(element => ({ ...element, isupdate: true })));
//       setShowUpdateModal(true);
//     }
//   };

//   const updaterecord = async () => {
//     try {
//       // Get all records
//       let updatedata = body.filter((value) => value.isupdate === true);

//       console.log("All records to update:", updatedata);

//       if (updatedata.length === 0) {
//         toast.info("No changes to save");
//         handleCloseModal();
//         return;
//       }

//       // Clean the data for backend
//       updatedata = updatedata.map(record => {
//         const cleanRecord = {
//           id: record.id || null, // Allow null for new records
//           key: record.key,
//           value: record.value,
//           isenabled: record.isenabled !== undefined ? record.isenabled : true,
//           description: record.description || ""
//         };

//         // Format value based on key type
//         if (record.key === "blood_group") {
//           cleanRecord.value = record.value === true || record.value === "true";
//         } else if (record.key === "id_card_color") {
//           cleanRecord.value = record.value || "#000000";
//         } else if (["frequency", "late_fee", "pending_due_day"].includes(record.key)) {
//           cleanRecord.value = parseInt(record.value) || 0;
//         }

//         return cleanRecord;
//       });

//       console.log("Sending to backend:", JSON.stringify(updatedata, null, 2));

//       const result = await schoolApi.updateallSettings(updatedata);
//       console.log("Response from backend:", result);

//       if (result.success) {
//         setAttendanceType(attendanceMode);
//         toast.success("Settings updated successfully!");
//         await fetchAllSettings(); // Refresh
//         handleCloseModal();
//       } else {
//         toast.error("Failed to update settings");
//         handleCloseModal();
//       }
//     } catch (error) {
//       console.error("Error during update:", error);
//       toast.error(error.response?.data?.message || "Something went wrong");
//     }
//   };

//   const changevalues = (e) => {
//     const { name, value, type, checked } = e.target;
//     const actualValue = type === 'checkbox' ? checked : value;

//     console.log(`Changing ${name} to:`, actualValue);

//     // Validation for pending due day
//     if (name === "pending_due_day") {
//       const parsedValue = parseInt(value, 10);
//       if (isNaN(parsedValue) || parsedValue < 0 || parsedValue >= 28) {
//         toast.error("Pending Due Day must be between 0 and 27.");
//         return;
//       }
//       setfeesPandingDays(parsedValue);
//     }

//     // Update body state
//     setBody((prev) => {
//       if (!prev) return prev;
//       const updated = prev.map((element) =>
//         element.key === name ? { ...element, value: actualValue, isupdate: true } : element
//       );
//       return updated;
//     });

//     // Update individual state variables
//     switch (name) {
//       case "frequency":
//         setfeefrequency(actualValue);
//         break;
//       case "Attendentce_Mode":
//         setattendanceMode(actualValue);
//         break;
//       case "late_fee":
//         setlateFees(actualValue);
//         break;
//       case "result_mode":
//         setResultMode(actualValue);
//         break;
//       case "id_card_color":
//         setTempColor(actualValue);
//         break;
//       case "blood_group":
//         setShowBloodGroup(actualValue);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleCloseModal = () => {
//     setShowUpdateModal(false);
//     setButtonvalue("Edit Settings");
//     setisEdit(true);
//     fetchAllSettings();
//   };

//   return (
//     <>
//       <Helmet>
//         <title>{tabName}</title>
//       </Helmet>

//       {showUpdateModal && (
//         <Confirm
//           show={showUpdateModal}
//           onHide={() => handleCloseModal()}
//           handleDelete={() => updaterecord()}
//           title="Confirm Update?"
//           message="You are going to update the record. Are you sure?"
//           table="deleteSession"
//         />
//       )}

//       <Row className="g-0">
//         <Row lg={12} className="p-lg-4" style={{ marginTop: "-20px" }}>
//           <Col lg={2} className="mt-2">
//             <Link className="nav-link" to="/">
//               Home <i className="fa-solid fa-chevron-right"></i> Settings
//             </Link>
//           </Col>
//           <Col
//             xs={12}
//             sm={6}
//             lg={10}
//             className="d-flex flex-col justify-content-end align-items-end"
//           >
//             {(userInfo?.userrole === "SYS_ADMIN" ||
//               userInfo?.userrole === "ADMIN" ||
//               canCreate) && (
//               <Button
//                 className="btn-light add-new-button"
//                 variant=""
//                 onClick={() => EditSetting()}
//               >
//                 {buttonvalue}
//               </Button>
//             )}
//           </Col>
//         </Row>

//         <Row className="g-2 mt-2">
//           <Card bg="white" key="white" text="dark" className="mb-2" style={{ marginTop: "-18px" }}>
//             <Card.Header className="bg-dark text-white">
//               <h4>Fees Settings</h4>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-2">
//                 <Col lg={6} className="gx-5">
//                   <Row className="mt-2">
//                     <Col lg={6} sm={8}>
//                       <Card.Title>Fee Frequency</Card.Title>
//                       <small>Specify the number of days after which the fee amount will increase.</small>
//                     </Col>
//                     <Col lg={6} sm={4} className="d-flex align-items-center">
//                       <Form.Control
//                         type="number"
//                         min="0"
//                         name="frequency"
//                         onChange={changevalues}
//                         value={feeFrequency}
//                         disabled={isedit}
//                       />
//                     </Col>
//                   </Row>
//                 </Col>
//                 <Col lg={6} className="gx-5">
//                   <Row className="mt-2">
//                     <Col lg={6} sm={8}>
//                       <Card.Title>Late Fee</Card.Title>
//                       <small>Specify the penalty amount applied for late payments after the due date.</small>
//                     </Col>
//                     <Col lg={6} sm={4} className="d-flex align-items-center">
//                       <Form.Control
//                         type="number"
//                         min="0"
//                         name="late_fee"
//                         onChange={changevalues}
//                         value={lateFees}
//                         disabled={isedit}
//                       />
//                     </Col>
//                   </Row>
//                 </Col>
//               </Row>
//               <Row className="g-2">
//                 <Col lg={6} className="gx-5">
//                   <Row className="mt-2">
//                     <Col lg={6} sm={8}>
//                       <Card.Title>Fees Due Date</Card.Title>
//                       <small>Specify the date to be considered as the due date for each installment.</small>
//                     </Col>
//                     <Col lg={6} sm={4} className="d-flex align-items-center">
//                       <Form.Control
//                         type="number"
//                         min="1"
//                         max="31"
//                         name="pending_due_day"
//                         onChange={changevalues}
//                         value={feesPandingDays}
//                         disabled={isedit}
//                       />
//                     </Col>
//                   </Row>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>

//           <Card>
//             <Card.Header className="bg-dark text-white">
//               <h4>Other Settings</h4>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-2">
//                 <Row className="mt-2">
//                   <Col lg={3} sm={8}>
//                     <Card.Title>Attendance Mode</Card.Title>
//                     <small>Specify whether student attendance will be tracked on a 'Daily' or 'Monthly' basis.</small>
//                   </Col>
//                   <Col lg={3} sm={4} className="d-flex align-items-center">
//                     <Form.Select
//                       name="Attendentce_Mode"
//                       disabled={isedit}
//                       onChange={changevalues}
//                       value={attendanceMode}
//                     >
//                       <option value="">--Select--</option>
//                       <option value="monthly">Monthly</option>
//                       <option value="daily">Daily</option>
//                     </Form.Select>
//                   </Col>

//                   <Col lg={3} sm={8}>
//                     <Card.Title>Exam Type Mode</Card.Title>
//                     <small>Specify the mode of result.</small>
//                   </Col>
//                   <Col lg={3} sm={4} className="d-flex align-items-center">
//                     <Form.Select
//                       name="result_mode"
//                       disabled={isedit}
//                       onChange={changevalues}
//                       value={resultMode}
//                     >
//                       <option value="">--Select--</option>
//                       <option value="percentage">Percentage</option>
//                       <option value="grade">Grade</option>
//                     </Form.Select>
//                   </Col>
//                 </Row>

//                 <Row className="mt-2">
//                   <Col lg={3} sm={8}>
//                     <Card.Title>Id Card Color</Card.Title>
//                     <small>Set the id card color (Hex code)</small>
//                   </Col>
//                   <Col lg={3} sm={4} className="d-flex align-items-center">
//                     <Form.Control
//                       type="color"
//                       disabled={isedit}
//                       value={tempColor}
//                       onChange={(e) => {
//                         const hexColor = e.target.value;
//                         setTempColor(hexColor);
//                         changevalues({ 
//                           target: { 
//                             name: "id_card_color", 
//                             value: hexColor,
//                             type: "color"
//                           } 
//                         });
//                       }}
//                       style={{ width: "60px", height: "40px", padding: "2px" }}
//                     />
//                     <span className="ms-2">{tempColor}</span>
//                   </Col>

//                   <Col lg={3} sm={8}>
//                     <Card.Title>Blood Group</Card.Title>
//                     <small>Show/hide blood group on id card</small>
//                   </Col>
//                   <Col lg={3} sm={4} className="d-flex align-items-center gap-3">
//                     <Form.Check
//                       type="checkbox"
//                       className="fs-4"
//                       disabled={isedit}
//                       checked={showBloodGroup}
//                       onChange={(e) => {
//                         const isChecked = e.target.checked;
//                         setShowBloodGroup(isChecked);
//                         changevalues({ 
//                           target: { 
//                             name: "blood_group", 
//                             type: "checkbox",
//                             checked: isChecked 
//                           } 
//                         });
//                       }}
//                       label={showBloodGroup ? "Enabled" : "Disabled"}
//                     />
//                   </Col>
//                 </Row>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Row>
//       </Row>

//       <ToastContainer
//         position="top-right"
//         autoClose={2000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
//     </>
//   );
// }

// export default SettingList;

import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import { SessionContext } from "../SessionProvider";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Confirm from "../Confirm";
import { usePermissions } from "../contexts/PermissionContext";
import { Helmet } from "react-helmet";
import IdCardDesignerModal from "../studentAdmission/IdCardDesignerModal";

function SettingList({ setAttendanceType, tabName }) {
  const [isedit, setisEdit] = useState(true);
  const [buttonvalue, setButtonvalue] = useState("Edit Settings");
  const { rolePermissions, userInfo } = usePermissions();
  const { selectedSessionId } = useContext(SessionContext);
  const [body, setBody] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [feeFrequency, setfeefrequency] = useState(0);
  const [lateFees, setlateFees] = useState(0);
  const [feesPandingDays, setfeesPandingDays] = useState(0);
  const [attendanceMode, setattendanceMode] = useState("daily");
  const [receiptNumberMode, setReceiptNumberMode] = useState("auto");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [resultMode, setResultMode] = useState("percentage");
  const [gradedata, setgradedata] = useState("");
  const canCreate = rolePermissions?.session_list?.can_create;

  const [tempColor, setTempColor] = useState("#000000");
  const [tempTextColor, setTempTextColor] = useState("#f7f2f2");
  const [showBloodGroup, setShowBloodGroup] = useState(false);
  const [showCardDesigner, setShowCardDesigner] = useState(false);
  const [designerOrientation, setDesignerOrientation] = useState("vertical");
  const [activeCardOrientation, setActiveCardOrientation] = useState("vertical");

  const[paperOrientation,setpaperOrientation] = useState('landscape')

  const changePaper=(e)=>{
    const value = e.target.value;
    console.log("value",value)
    setpaperOrientation(value)
  }

  useEffect(() => {
    fetchAllSettings();
    fetchgrade();
  }, []);

  useEffect(() => {
    fetchStudentPreviewList();
  }, [selectedSessionId]);

  const fetchStudentPreviewList = async () => {
    if (!selectedSessionId) {
      setStudentList([]);
      return;
    }

    try {
      const result = await schoolApi.fetchStudentAddmission(selectedSessionId);
      if (result?.success) {
        setStudentList(result.studentAddmision || []);
      } else {
        setStudentList([]);
      }
    } catch (error) {
      console.error("Error fetching student preview list:", error);
      setStudentList([]);
    }
  };

  const fetchgrade = async () => {
    try {
      const data = await schoolApi.fetchgrade();
      if (data && data.grades) {
        setgradedata(
          data.grades.map((grade) => ({ ...grade, isupdate: false })),
        );
      } else {
        setgradedata([]);
      }
    } catch (error) {
      console.error("Error fetching grades:", error.message);
    }
  };

  async function fetchAllSettings() {
    try {
      const result = await schoolApi.getAllSetting();

      if (result && result.data) {
        console.log("Fetched settings:", result.data);

        // Check if id_card_color and blood_group exist
        const hasIdCardColor = result.data.some(r => r.key === "id_card_color");
        const hasIdCardTextColor = result.data.some(r => r.key === "id_card_text_color");
        const hasBloodGroup = result.data.some(r => r.key === "blood_group");
        const hasAttendanceMode = result.data.some(r => r.key === "Attendentce_Mode");
        

        const hasResultMode = result.data.some(
          r => r.key === "result_mode"
        );
        let settingsData = [...result.data];

        // If missing, add them to the list
        if (!hasIdCardColor) {
          console.log("Adding missing id_card_color setting");
          settingsData.push({
            id: null,
            key: "id_card_color",
            value: "#000000",
            isenabled: true,
            description: "ID Card Color",
            isupdate: true
          });
        }
        //text color
        if (!hasIdCardTextColor) {
          console.log("Adding missing id_card_text_color setting");
          settingsData.push({
            id: null,
            key: "id_card_text_color",
            value: "#ffffff",
            isenabled: true,
            description: "ID Card Text Color",
            isupdate: true
          });
        }
        if (!hasBloodGroup) {
          console.log("Adding missing blood_group setting");
          settingsData.push({
            id: null,
            key: "blood_group",
            value: false,
            isenabled: true,
            description: "Show Blood Group on ID Card",
            isupdate: true
          });
        }
        const hasActiveOrientation = result.data.some(r => r.key === "id_card_active_orientation");
        if (!hasActiveOrientation) {
          settingsData.push({
            id: null,
            key: "id_card_active_orientation",
            value: "vertical",
            isenabled: true,
            description: "Active ID Card Orientation for Printing",
            isupdate: true
          });
        }
        if (!hasAttendanceMode) {
          settingsData.push({
            id: null,
            key: "Attendentce_Mode",
            value: "daily",
            isenabled: true,
            description: "Attendance Mode",
            isupdate: true
          });
        }
        if (!hasResultMode) {
          settingsData.push({
            id: null,
            key: "result_mode",
            value: "percentage",
            isenabled: true,
            description: "Result Mode",
            isupdate: true
          });
        }
        const hasReceiptMode = result.data.some(r => r.key === "receipt_number_mode");
        if (!hasReceiptMode) {
          settingsData.push({
            id: null,
            key: "receipt_number_mode",
            value: "auto",
            isenabled: true,
            description: "Receipt Number Generation Mode",
            isupdate: true
          });
        }

        if (!hasAttendanceMode) {
          settingsData.push({
            id: null,
            key: "Attendentce_Mode",
            value: "daily",
            isenabled: true,
            description: "Attendance Mode",
            isupdate: true
          });
        }
        if (!hasResultMode) {
          settingsData.push({
            id: null,
            key: "result_mode",
            value: "percentage",
            isenabled: true,
            description: "Result Mode",
            isupdate: true
          });
        }

        setBody(settingsData.map((element) => ({ ...element, isupdate: false })));

        // Set state variables
        settingsData.forEach((element) => {
          switch (element.key) {
            case "frequency":
              setfeefrequency(parseInt(element.value) || 0);
              break;
            case "Attendentce_Mode":
              setattendanceMode(element.value);
              break;
            case "pending_due_day":
              setfeesPandingDays(parseInt(element.value) || 0);
              break;
            case "late_fee":
              setlateFees(parseInt(element.value) || 0);
              break;
            case "result_mode":
              setResultMode(element.value);
              break;
            case "receipt_number_mode":
              setReceiptNumberMode(element.value || "auto");
              break;
            case "id_card_color":
              setTempColor(element.value || "#000000");
              break;
            case "id_card_text_color":
              setTempTextColor(element.value || "#f7f2f2");
              break;
            case "blood_group":
              const isBloodGroupEnabled = element.value === true || element.value === "true";
              setShowBloodGroup(isBloodGroupEnabled);
              break;
            case "id_card_active_orientation":
              setActiveCardOrientation(element.value || "vertical");
              break;
            default:
              break;
          }
        });
      }
    } catch (error) {
      console.error("Error during fetchAllSettings:", error);
      toast.error("Something went wrong");
    }
  }

  const EditSetting = () => {
    if (buttonvalue === "Edit Settings") {
      setisEdit(false);
      setButtonvalue("Save Settings");
    } else {
      // Before saving, ensure all settings are marked for update
      setBody(prev => prev.map(element => ({ ...element, isupdate: true })));
      setShowUpdateModal(true);
    }
  };

  const updaterecord = async () => {
    try {
      // Get all records
      let updatedata = body.filter((value) => value.isupdate === true);
      console.log("All records to update:", updatedata);
      if (updatedata.length === 0) {
        toast.info("No changes to save");
        handleCloseModal();
        return;
      }
      // Clean the data for backend
      updatedata = updatedata.map(record => {
        const cleanRecord = {
          id: record.id || null, // Allow null for new records
          key: record.key,
          value: record.value,
          isenabled: record.isenabled !== undefined ? record.isenabled : true,
          description: record.description || ""
        };
        // Format value based on key type
        if (record.key === "blood_group") {
          cleanRecord.value = record.value === true || record.value === "true";
        } else if (record.key === "id_card_color") {
          cleanRecord.value = record.value || "#000000";
        } else if (["frequency", "late_fee", "pending_due_day"].includes(record.key)) {
          cleanRecord.value = parseInt(record.value) || 0;
        } else if (record.key === "id_card_text_color") {
          cleanRecord.value = record.value || "#ffffff";
        }
        return cleanRecord;
      });

      console.log("Sending to backend:", JSON.stringify(updatedata, null, 2));

      const result = await schoolApi.updateallSettings(updatedata);
      console.log("Response from backend:", result);

      if (result.success) {
        setAttendanceType(attendanceMode);
        toast.success("Settings updated successfully!");
        await fetchAllSettings(); // Refresh
        handleCloseModal();
      } else {
        toast.error("Failed to update settings");
        handleCloseModal();
      }
    } catch (error) {
      console.error("Error during update:", error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const changevalues = (e) => {
    const { name, value, type, checked } = e.target;
    const actualValue = type === 'checkbox' ? checked : value;

    console.log(`Changing ${name} to:`, actualValue);

    // Validation for pending due day
    if (name === "pending_due_day") {
      const parsedValue = parseInt(value, 10);
      if (isNaN(parsedValue) || parsedValue < 0 || parsedValue >= 28) {
        toast.error("Pending Due Day must be between 0 and 27.");
        return;
      }
      setfeesPandingDays(parsedValue);
    }

    // Update body state
    setBody((prev) => {
      if (!prev) return prev;
      const updated = prev.map((element) =>
        element.key === name ? { ...element, value: actualValue, isupdate: true } : element
      );
      return updated;
    });

    // Update individual state variables
    switch (name) {
      case "frequency":
        setfeefrequency(actualValue);
        break;
      case "Attendentce_Mode":
        setattendanceMode(actualValue);
        break;
      case "late_fee":
        setlateFees(actualValue);
        break;
      case "result_mode":
        setResultMode(actualValue);
        break;
      case "receipt_number_mode":
        setReceiptNumberMode(actualValue);
        break;
      case "id_card_color":
        setTempColor(actualValue);
        break;
      case "id_card_text_color":
        setTempTextColor(actualValue);
        break;
      case "id_card_active_orientation":
        setActiveCardOrientation(actualValue);
        break;
      case "blood_group":
        setShowBloodGroup(actualValue);
        break;
      default:
        break;
    }
  };

  const handleCloseModal = () => {
    setShowUpdateModal(false);
    setButtonvalue("Edit Settings");
    setisEdit(true);
    fetchAllSettings();
  };

  return (
    <>
      <Helmet>
        <title>{tabName}</title>
      </Helmet>

      {showUpdateModal && (
        <Confirm
          show={showUpdateModal}
          onHide={() => handleCloseModal()}
          handleDelete={() => updaterecord()}
          title="Confirm Update?"
          message="You are going to update the record. Are you sure?"
          table="deleteSession"
        />
      )}

      <Row className="g-0">
        <Row lg={12} className="p-lg-4" style={{ marginTop: "-20px" }}>
          <Col lg={2} className="mt-2">
            <Link className="nav-link" to="/">
              Home <i className="fa-solid fa-chevron-right"></i> Settings
            </Link>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={10}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            {(userInfo?.userrole === "SYS_ADMIN" ||
              userInfo?.userrole === "ADMIN" ||
              canCreate) && (
                <Button
                  className="btn-light add-new-button"
                  variant=""
                  onClick={() => EditSetting()}
                >
                  {buttonvalue}
                </Button>
              )}
          </Col>
        </Row>

        <Row className="g-2 mt-2">
          <Card bg="white" key="white" text="dark" className="mb-2" style={{ marginTop: "-18px" }}>
            <Card.Header className="bg-dark text-white">
              <h4>Fees Settings</h4>
            </Card.Header>
            <Card.Body>
              <Row className="g-2">
                <Col lg={6} className="gx-5">
                  <Row className="mt-2">
                    <Col lg={6} sm={8}>
                      <Card.Title>Fee Frequency</Card.Title>
                      <small>Specify the number of days after which the fee amount will increase.</small>
                    </Col>
                    <Col lg={6} sm={4} className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        min="0"
                        name="frequency"
                        onChange={changevalues}
                        value={feeFrequency}
                        disabled={isedit}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} className="gx-5">
                  <Row className="mt-2">
                    <Col lg={6} sm={8}>
                      <Card.Title>Late Fee</Card.Title>
                      <small>Specify the penalty amount applied for late payments after the due date.</small>
                    </Col>
                    <Col lg={6} sm={4} className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        min="0"
                        name="late_fee"
                        onChange={changevalues}
                        value={lateFees}
                        disabled={isedit}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="g-2">
                <Col lg={6} className="gx-5">
                  <Row className="mt-2">
                    <Col lg={6} sm={8}>
                      <Card.Title>Fees Due Date</Card.Title>
                      <small>Specify the date to be considered as the due date for each installment.</small>
                    </Col>
                    <Col lg={6} sm={4} className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        min="1"
                        max="31"
                        name="pending_due_day"
                        onChange={changevalues}
                        value={feesPandingDays}
                        disabled={isedit}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} className="gx-5">
                  <Row className="mt-2">
                    <Col lg={6} sm={8}>
                      <Card.Title>Receipt Number Mode</Card.Title>
                      <small>Select 'Auto' for automatic sequence generation or 'Manual' for manual entry.</small>
                    </Col>
                    <Col lg={6} sm={4} className="d-flex align-items-center">
                      <Form.Select
                        name="receipt_number_mode"
                        onChange={changevalues}
                        value={receiptNumberMode}
                        disabled={isedit}
                      >
                        <option value="auto">Auto</option>
                        <option value="manual">Manual</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header className="bg-dark text-white">
              <h4>Other Settings</h4>
            </Card.Header>
            <Card.Body>
              <Row className="g-2">
                <Row className="mt-2">
                  <Col lg={3} sm={8}>
                    <Card.Title>Attendance Mode</Card.Title>
                    <small>Specify whether student attendance will be tracked on a 'Daily' or 'Monthly' basis.</small>
                  </Col>
                  <Col lg={3} sm={4} className="d-flex align-items-center">
                    <Form.Select
                      name="Attendentce_Mode"
                      disabled={isedit}
                      onChange={changevalues}
                      value={attendanceMode}
                    >
                      <option value="">--Select--</option>
                      <option value="monthly">Monthly</option>
                      <option value="daily">Daily</option>
                    </Form.Select>
                  </Col>

                  <Col lg={3} sm={8}>
                    <Card.Title>Exam Type Mode</Card.Title>
                    <small>Specify the mode of result.</small>
                  </Col>
                  <Col lg={3} sm={4} className="d-flex align-items-center">
                    <Form.Select
                      name="result_mode"
                      disabled={isedit}
                      onChange={changevalues}
                      value={resultMode}
                    >
                      <option value="">--Select--</option>
                      <option value="percentage">Percentage</option>
                      <option value="grade">Grade</option>
                    </Form.Select>
                  </Col>
                </Row>
                {/* id card color and blood group setting */}
                <Row className="mt-2">
                  <Col lg={3} sm={8}>
                    <Card.Title>Id Card Color</Card.Title>
                    <small>Set the id card color (Hex code)</small>
                  </Col>
                  <Col lg={3} sm={4} className="d-flex align-items-center">
                    <Form.Control
                      type="color"
                      disabled={isedit}
                      value={tempColor}
                      onChange={(e) => {
                        const hexColor = e.target.value;
                        setTempColor(hexColor);
                        changevalues({
                          target: {
                            name: "id_card_color",
                            value: hexColor,
                            type: "color"
                          }
                        });
                      }}
                      style={{ width: "60px", height: "40px", padding: "2px" }}
                    />
                    <span className="ms-2">{tempColor}</span>
                  </Col>


                  <Col lg={3} sm={8}>
                    <Card.Title>Id Card Text Color</Card.Title>
                    <small>Set the id card text color (Hex code)</small>
                  </Col>
                  <Col lg={3} sm={4} className="d-flex align-items-center">
                    <Form.Control
                      type="color"
                      disabled={isedit}
                      value={tempTextColor}
                      onChange={(e) => {
                        const hexColor = e.target.value;
                        setTempTextColor(hexColor);
                        changevalues({
                          target: {
                            name: "id_card_text_color",
                            value: hexColor,
                            type: "color"
                          }
                        });
                      }}
                      style={{ width: "60px", height: "40px", padding: "2px" }}
                    />
                    <span className="ms-2">{tempTextColor}</span>
                  </Col>
                </Row>
                {/* text color setting */}
                <Row className="mt-2">
                  <Col lg={3} sm={8}>
                    <Card.Title>Blood Group</Card.Title>
                    <small>Show/hide blood group on id card</small>
                  </Col>
                  <Col lg={3} sm={4} className="d-flex align-items-center gap-3">
                    <Form.Check
                      type="checkbox"
                      className="fs-4"
                      disabled={isedit}
                      checked={showBloodGroup}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowBloodGroup(isChecked);
                        changevalues({
                          target: {
                            name: "blood_group",
                            type: "checkbox",
                            checked: isChecked
                          }
                        });
                      }}
                      label={showBloodGroup ? "Enabled" : "Disabled"}
                    />
                  </Col>
                </Row>
                <Row className="mt-4 pt-3 border-top">
                  <Col lg={6} sm={12}>
                    <Card.Title className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-wand-magic-sparkles text-primary"></i>
                      Dynamic ID Card Template Designer
                    </Card.Title>
                    <small className="text-muted">
                      Open drag-and-drop studio to customize layout, student fields, custom dimensions, typography, and styling for Vertical and Horizontal ID cards.
                    </small>
                  </Col>
                  <Col lg={6} sm={12} className="d-flex flex-column gap-2 gap-lg-3 mt-2 mt-lg-0">
                    <div className="d-flex flex-wrap gap-2 align-items-center">
                      <Button
                        variant="outline-primary"
                        className="d-flex align-items-center gap-2"
                        onClick={() => {
                          setDesignerOrientation("vertical");
                          setShowCardDesigner(true);
                        }}
                      >
                        <i className="fa-solid fa-arrow-up"></i> Design Vertical Card
                      </Button>
                      <Button
                        variant="outline-primary"
                        className="d-flex align-items-center gap-2"
                        onClick={() => {
                          setDesignerOrientation("horizontal");
                          setShowCardDesigner(true);
                        }}
                      >
                        <i className="fa-solid fa-arrow-right"></i> Design Horizontal Card
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3 pt-3 border-top align-items-center">
                  <Col lg={6} sm={12}>
                    <Form.Label className="mb-0 fw-bold d-flex align-items-center gap-2">
                      <i className="fa-solid fa-check-to-slot text-success"></i>
                      Active Printing Layout Mode
                    </Form.Label>
                    <div className="text-muted small mt-1">
                      Choose which designed card orientation is applied automatically when printing ID cards anywhere in the software.
                    </div>
                  </Col>
                  <Col lg={3} sm={12} className="mt-2 mt-lg-0">
                    <Form.Select
                      name="id_card_active_orientation"
                      value={activeCardOrientation}
                      disabled={isedit}
                      onChange={changevalues}
                      style={{ maxWidth: "280px" }}
                    >
                      <option value="vertical">Vertical Layout (Default / Saved Design)</option>
                      <option value="horizontal">Horizontal Layout (Default / Saved Design)</option>
                    </Form.Select>
                  </Col>

                   <Col lg={3} sm={12} className="mt-2 mt-lg-0">
                    <Form.Select
                      name="id_card_active_orientation"
                      value={paperOrientation}
                      disabled={isedit}
                      onChange={changePaper}
                      style={{ maxWidth: "280px" }}
                    >
                      <option value="portrait">portrait (Default / Saved Design)</option>
                      <option value="landscape">landscape(Default / Saved Design)</option>
                    </Form.Select>
                  </Col>
                </Row>
                
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </Row>

      {showCardDesigner && (
        <IdCardDesignerModal
          show={showCardDesigner}
          onHide={() => setShowCardDesigner(false)}
          settingsList={body}
          studentList={studentList}
          userInfo={userInfo}
          initialOrientation={designerOrientation}
          onSaveSuccess={() => {
            fetchAllSettings();
          }}
        />
      )}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default SettingList;